import { useRouter } from "next/router";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { NextStepsPage } from "@nju/feature-portal-registration";
import { portalRoutes } from "@nju/routes";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function NextSteps() {
  const router = useRouter();
  const params = portalRoutes.kolejneKroki.input(router.query).unwrap();

  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl">
        <ClientSideOnly>
          <NextStepsPage offerId={params?.oferta} />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
